import { Navigation } from "../../../../scripts/modules/navigation/navigation";

/* eslint-disable func-names */
/* eslint-disable no-unused-vars */
/* eslint-disable no-undef */

// eslint-disable-next-line no-undef
let $globalConfig;
if (document.querySelectorAll('.catalog').length > 0 || document.querySelectorAll('.eifu').length > 0 || document.querySelectorAll('.ks-legacy').length > 0) {
    $globalConfig = config;
}

jQuery('body').on('click', '.ks-btn-order', function (e) {


    const button = jQuery(this);

    const basketLink = button.attr('data-basket');
    const productTitle = button.attr('data-title');

    if (basketLink !== '') {
        $.get(basketLink, (data) => {
            const mediaquery = window.matchMedia('(max-width: 991px)');

            if (mediaquery.matches) {
                $('#ks-cart-count').replaceWith(data);
                $('#ks-mobile-button-cart').animate({ opacity: 0 }, 500);
                $('#ks-mobile-button-cart').addClass('full');
                $('#ks-mobile-button-cart').animate({ opacity: 1 }, 500);
            } else {
                $('#ks-top-cart-dialog').animate({ opacity: 0 }, 500);
                $('#ks-cart-count').replaceWith(data);
                $('#ks-top-cart-dialog').animate({ opacity: 1 }, 500);
                $('#ks-mobile-button-cart').addClass('full');
            }

            Navigation.updateCartNumber();

            toastr.options.onclick = () => {
                const $basketLink = $('.navigation__action.navigation__action--favorite > a');

                if ($basketLink.length) {
                    // click the basket link so that the user
                    // navigates to the basket page when he
                    // clicked a toastr popup
                    $basketLink[0].click();
                }

                toastr.options.onclick = null;
            };

            toastr.info(`<div><b>${productTitle}</b> ${$globalConfig.labels.add_to}.</div>`);
        });
    }

    return false;
});
